import { ca } from '@cian/analytics';

/**
 * СОБЫТИЯ ФЛОУ АВТОРИЗАЦИИ ПО ТЕЛЕФОНУ
 */

/**
 * Клик по ссылке отправить еще раз
 */
export function trackPhoneAuthResendValidationCode() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_send_again'
  });
}

/**
 * Клик на "Мне не позвонили" при авторизации/регистрации через последние 4 цифры телефона
 */
export function trackPhoneAuthResendCodeClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_resend_code',
    label: 'last_phone_numbers'
  });
}

/**
 * Введен неверный код подтверждения, полученный по СМС
 */
export function trackPhoneAuthSmsValidationFail() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_simple'
  });
}

/**
 * Введен неверный код подтверждения, полученный по телефонному звонку
 */
export function trackPhoneAuthCallValidationFail() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'last_phone_numbers'
  });
}

/**
 * Введен неверный код, превышено кол-во попыток
 */
export function trackPhoneAuthExhausted() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Fail',
    label: 'phone_fatal'
  });
}

/**
 * Клик по кнопке продолжить, после ввода телефона
 */
export function trackPhoneAuthResumeButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_continue'
  });
}

/**
 * Клик по ссылке нужна помощь
 */
export function trackPhoneAuthNeedHelp() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click',
    label: 'phone_cant_confirm'
  });
}

/**
 * Показ экрана с запросом на ввод 4 последних цифр номера телефона
 */
export function trackPhoneAuthCallShow() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Open',
    label: 'last_phone_numbers'
  });
}

/**
 * Клик на "Ввести заново" при авторизации/регистрации через звонок
 * Кнопка появляется в результате некорректной отправки кода
 */
export function trackPhoneAuthCallReEnterButtonClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'AuthBlock',
    action: 'Click_re_enter_phone_code',
    label: 'last_phone_numbers'
  });
}